import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DirectivesModule } from '../../../../directives/directives.module';
import { NavSettingsSubmenuPage } from './nav-settings-submenu';

@NgModule({
  declarations: [NavSettingsSubmenuPage],
  imports: [DirectivesModule, IonicPageModule.forChild(NavSettingsSubmenuPage)]
})
export class NavSettingsSubmenuPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-settings-submenu/nav-settings-submenu.module.ts